<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-card [appearance]="example.appearance" direction="column">
            <uilab-mat-card-header>
                <uilab-mat-card-title
                    >{{ example.variant | titlecase }} card - Title</uilab-mat-card-title
                >
                <uilab-mat-card-subtitle>Subtitle</uilab-mat-card-subtitle>
            </uilab-mat-card-header>

            <uilab-mat-card-content>
                Uilab mat card content 1
            </uilab-mat-card-content>
        </uilab-mat-card>
    </avd-code-example>
}